import PhoneArea from "components/PhonePreview/PhoneArea"
import { FORM_NAMES } from "constants/index"
import React from "react"
import { connect } from "react-redux"
import { formValueSelector } from "redux-form"
import Boxes from "./LayoutPreviews/boxes"
import Cards from "./LayoutPreviews/cards"
import Carousel from "./LayoutPreviews/carousel"
import Circles from "./LayoutPreviews/circles"
import Grid from "./LayoutPreviews/grid"
import SimpleStack from "./LayoutPreviews/simpleStack"

const PhonePreview = ({
  layout = "3",
  bgImage,
  bgColor,
  headerColor,
  headerImage,
  title = "",
  textColor,
  textFont,
  userListToggle,
  contactUsToggle,
  codesToggle,
  inboxToggle,
}) => {
  const previewData = [
    {
      name: "Experience 1",
      img: "https://admin.dev.markedprivate.com/app/images/image_placeholder.jpg",
      boxShadow: "inset 0 0 0 100px rgb(0 0 0 / 40%)",
    },
    {
      name: "Experience 2",
      img: "https://admin.dev.markedprivate.com/app/images/image_placeholder.jpg",
      boxShadow: "inset 0 0 0 100px rgb(197 85 85 / 25%)",
    },
    {
      name: "Experience 3",
      img: "https://admin.dev.markedprivate.com/app/images/image_placeholder.jpg",
      boxShadow: "inset 0 0 0 100px rgb(144 214 143 / 20%)",
    },
    {
      name: "Experience 4",
      img: "https://admin.dev.markedprivate.com/app/images/image_placeholder.jpg",
      boxShadow: "inset 0 0 0 100px rgb(123 131 224 / 30%)",
    },
  ]

  const renderPreview = () => {
    switch (layout) {
      case "2":
        return (
          <Cards
            previewData={previewData}
            headerColor={headerColor}
            textColor={textColor}
          />
        )
      case "3":
        return (
          <Boxes
            previewData={previewData}
            headerColor={headerColor}
            textColor={textColor}
          />
        )
      case "4":
        return (
          <Carousel
            headerColor={headerColor}
            textColor={textColor}
            bgImage="https://admin.dev.markedprivate.com/app/images/preview/list_screen_template4_bkg.png"
          />
        )
      case "5":
        return <Grid previewData={previewData} />
      case "6":
        return (
          <SimpleStack
            previewData={previewData}
            headerColor={headerColor}
            textColor={textColor}
          />
        )
      case "8":
        return (
          <Circles
            previewData={previewData}
            headerColor={headerColor}
            textColor={textColor}
          />
        )
      default:
        return <></>
    }
  }

  return (
    <PhoneArea>
      <div
        style={{
          backgroundImage: `url(${bgImage?.editedImage})`,
          backgroundColor: bgColor,
          width: "105%",
          height: "105%",
          backgroundSize: "cover",
          marginLeft: "-5px",
          backgroundPosition: "center center",
        }}
      >
        <div
          style={{
            width: "100%",
            height: "50px",
            backgroundColor: headerColor,
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <i
            className="bx bxs-home font-size-24"
            style={{
              color: textColor,
            }}
          />

          {headerImage && headerImage?.editedImage ? (
            layout === "6" || layout === "8" ? (
              <></>
            ) : (
              <div
                style={{
                  backgroundImage: `url(${headerImage?.editedImage})`,
                  width: "100px",
                  height: "auto",
                  backgroundSize: "contain",
                  minHeight: "50px",
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                }}
              />
            )
          ) : (
            <p
              style={{
                paddingBlockStart: "1em",
                color: textColor,
                fontFamily: textFont,
              }}
            >
              {title}
            </p>
          )}
          <i
            className="bx bxs-user-circle font-size-24 me-2"
            style={{
              color: textColor,
            }}
          />
        </div>
        {headerImage &&
        headerImage?.editedImage &&
        (layout === "6" || layout === "8") ? (
          <div
            style={{
              backgroundImage: `url(${headerImage?.editedImage})`,
              width: "70%",
              height: "auto",
              backgroundSize: "contain",
              minHeight: "100px",
              maxHeight: "30%",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              margin: "0 auto",
            }}
          />
        ) : (
          <></>
        )}
        {renderPreview()}
        <div
          style={{
            width: "100%",
            height: "40px",
            position: "absolute",
            bottom: "0",
            left: "0",
            backgroundColor: "black",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            color: "white",
          }}
        >
          <i className="mdi mdi-ballot font-size-20" />
          <i className="bx bx-file font-size-20" />
          {(userListToggle === 1 || userListToggle === true) && (
            <i className="mdi mdi-account-multiple font-size-20" />
          )}
          {(contactUsToggle === 1 || contactUsToggle === true) && (
            <i className="mdi mdi-contacts font-size-20" />
          )}
          {(inboxToggle === 1 || inboxToggle === true) && (
            <i className="bx bx-conversation font-size-20" />
          )}
          {(codesToggle === 1 || codesToggle === true) && (
            <i className="mdi mdi-qrcode font-size-20" />
          )}
          <i className="mdi mdi-bell font-size-20" />
        </div>
      </div>
    </PhoneArea>
  )
}

const selector = formValueSelector(FORM_NAMES.LIST_SCREEN)

const mapStateToProps = state => ({
  layout: selector(state, "layout.layout"),
  bgImage: selector(state, "background.bgImage"),
  bgColor: selector(state, "background.bgColor"),
  headerColor: selector(state, "header.headerColor"),
  headerImage: selector(state, "header.image"),
  title: selector(state, "header.title"),
  textColor: selector(state, "header.textColor"),
  textFont: selector(state, "header.textFont"),
  userListToggle: selector(state, "bottomMenu.userListToggle"),
  contactUsToggle: selector(state, "bottomMenu.contactUsToggle"),
  codesToggle: selector(state, "bottomMenu.codesToggle"),
  inboxToggle: selector(state, "bottomMenu.inboxToggle"),
})

export default connect(mapStateToProps)(PhonePreview)
